import Cookie from './_cookie';
import Storage from './_storages';
import Params from './_params';
import Common from './_common';

export default {
  Cookie,
  Storage,
  Params,
  Common
};



// WEBPACK FOOTER //
// ./src/utils/tools/index.js